import { useAtomValue } from 'jotai'

import { quoteSyncStatusAtom, type QuoteSyncStatus } from './quoteSync.atoms'

/**
 * Where the quote's auto-save has got to, for anything below
 * `QuoteSyncProvider` that only wants to read it. Above the provider it reads a
 * status nothing writes, so it always says IDLE.
 */
export const useQuoteSyncStatus = (): QuoteSyncStatus =>
  useAtomValue(quoteSyncStatusAtom)
